import { api } from '../axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';
import { GetPlayerDetailResponse } from '../type/types';

interface getPlayerDetailProps {
  playerId: string;
}
export const getPlayerDetail = async ({ playerId }: getPlayerDetailProps) => {
  const res = await api.get<ApiResponseType<GetPlayerDetailResponse>>(
    `/api/web/admins/players/${playerId}`
  );
  return res.data;
};
